import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../image/other-bg.png'


const _withScopeId = n => (_pushScopeId("data-v-15e0da24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "program" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program_img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "program_container" }
const _hoisted_4 = { class: "program_item" }
const _hoisted_5 = { class: "imgContainer" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "content" }

import { Autoplay, Navigation } from 'swiper'
import { Swiper, SwiperSlide, } from 'swiper/vue/swiper-vue';
import { ref } from 'vue';
import 'swiper/swiper-bundle.min.css'


export default /*#__PURE__*/_defineComponent({
  __name: 'Program',
  setup(__props) {

const moduleList = ref([Autoplay, Navigation])
const list = ref([
  { url: require('../image/program/linzhang.jpg'), title: '智慧林长综合管理平台', content: '智慧林长综合管理平台旨在生态保护、生态修复、灾害防控、深化改革、资源监测监管、基层基础建设、完善责任机制、健全考核制度、协调解决问题、行政执法等方面为政府部门提供完整的解决方案。' },
  { url: require('../image/program/keyan.jpg'), title: '科研监测系统', content: '科研监测系统依托移动互联网、大数据、云计算等生物资源调查和信息管理技术，全面系统地掌握全域生物资源信息，采集生物资源基础数据，科研监测系统为改进和完善森林资源清查方式，丰富监测成果信息，提高监测效率，满足林业决策和生态建设对森林资源宏观信息的需求而采用的系统。' },
  { url: require('../image/program/kepu.jpg'), title: '科普宣教系统', content: '科普宣教系统旨在提高林业主管部门的科普能力，帮助公众了解更多野生动植物保护方面的相关常识、知识，激发公众对亲近大自然、探索大自然、了解大自然、欣赏大自然、保护大自然的兴趣，选择健康、可持续发展生活方式，共建生态美好家园，助力生态明文建设。' }
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Swiper), {
        modules: moduleList.value,
        loop: true,
        navigation: true,
        autoplay: { delay: 3000 },
        pagination: {
          clickable: true,
        }
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
            return (_openBlock(), _createBlock(_unref(SwiperSlide), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("img", {
                      src: item.url,
                      alt: ""
                    }, null, 8, _hoisted_6)
                  ]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(item.content), 1)
                ])
              ]),
              _: 2
            }, 1024))
          }), 256))
        ]),
        _: 1
      }, 8, ["modules"])
    ])
  ]))
}
}

})